import { AbstractField } from './AbstractField';
import isNil from 'lodash/isNil';
import { makeObservable, override } from 'mobx';
import { translate } from '@chaika/i18n/helper';

export interface CheckboxWithTextFieldParams {
    isChecked: boolean;
    comment: string;
}

export class CheckboxWithTextField extends AbstractField<CheckboxWithTextFieldParams, CheckboxWithTextFieldParams> {
    constructor(params: CheckboxWithTextFieldParams, name: string) {
        super(params, name);
        makeObservable(this);
    }

    @override
    public get hasData(): boolean {
        return !isNil(this.fieldValue.isChecked) && this.fieldValue.isChecked !== false;
    }

    public getPreview(): string {
        const { isChecked, comment } = this.fieldValue;

        return isChecked ? comment : translate('notChosen');
    }

    public makeUpdateParams(): CheckboxWithTextFieldParams {
        return this.fieldValue;
    }

    public isEqual(value: CheckboxWithTextFieldParams): boolean {
        const { isChecked, comment } = this.fieldValue;

        return isChecked === value.isChecked && comment === value.comment;
    }

    protected setDefaultValueValue(): void {
        this.defaultNullValue = {} as CheckboxWithTextFieldParams;
    }

    protected setFieldValue(value: CheckboxWithTextFieldParams): void {
        this.fieldValue = value;
    }
}
